import{useSelector}from'react-redux';const useEditMode=()=>{return useSelector(state=>state.editMode);};export default useEditMode;